import { Link } from "react-router-dom";
import { Banknote, MessageCircle, RotateCcw, ShieldCheck } from "lucide-react";
import { useStoreConfig } from "../../features/config/queries";

interface Signal {
  icon: typeof Banknote;
  label: string;
  description: string;
  href?: string;
  external?: boolean;
}

export function TrustSignals() {
  const { data: config } = useStoreConfig();
  const whatsappNumber = config?.whatsappNumber?.replace(/[^\d]/g, "");

  const signals: Signal[] = [
    {
      icon: Banknote,
      label: "Cash on delivery",
      description: "Pay a small advance now, the rest when it arrives."
    },
    {
      icon: RotateCcw,
      label: "Easy returns",
      description: "Not right? Send it back on eligible items.",
      href: "/returns"
    },
    ...(whatsappNumber
      ? [
          {
            icon: MessageCircle,
            label: "Real human support",
            description: "Reach us on WhatsApp — no bots, no wait.",
            href: `https://wa.me/${whatsappNumber}`,
            external: true
          }
        ]
      : []),
    {
      icon: ShieldCheck,
      label: "Secure checkout",
      description: "Your details stay private, every order."
    }
  ];

  return (
    <section className="max-w-7xl mx-auto px-6 py-16">
      <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {signals.map((signal) => {
          const Icon = signal.icon;
          const content = (
            <div className="h-full rounded-2xl border border-border bg-surface p-5 flex flex-col gap-3 transition-colors duration-300 hover:border-accent/40">
              <Icon size={22} className="text-accent" aria-hidden />
              <div>
                <p className="text-sm font-medium text-ink">{signal.label}</p>
                <p className="text-xs text-ink-muted mt-1 leading-relaxed">{signal.description}</p>
              </div>
            </div>
          );

          if (signal.href && signal.external) {
            return (
              <a key={signal.label} href={signal.href} target="_blank" rel="noreferrer" className="block h-full">
                {content}
              </a>
            );
          }
          if (signal.href) {
            return (
              <Link key={signal.label} to={signal.href} className="block h-full">
                {content}
              </Link>
            );
          }
          return (
            <div key={signal.label} className="h-full">
              {content}
            </div>
          );
        })}
      </div>
    </section>
  );
}
